import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { PRODUCTS, BUNDLE } from "@/data/products";
import ProductCard from "@/components/ProductCard";
import { Reveal, StaggerItem } from "@/components/Reveal";
import pouches from "@/assets/brand/pouches.png";

const ProductShowcase = () => {
  const { t } = useLang();
  const supplements = PRODUCTS.filter((p) => p.category === "supplement" && !p.soldOut);

  return (
    <section id="products" className="bg-blush border-b border-ink py-20 md:py-28" data-testid="products">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="kicker text-pink">{t.productsKicker}</p>
          <h2 className="display uppercase text-5xl md:text-7xl leading-[0.85] mt-3 text-brand">{t.productsTitle}</h2>
          <p className="mt-4 text-lg font-medium text-ink/70">{t.productsSub}</p>
        </Reveal>

        <StaggerItem className="mt-12">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink border border-ink">
            {supplements.map((p) => (
              <ProductCard key={p.id} product={p} attached />
            ))}
          </div>
        </StaggerItem>

        {/* Bundle banner */}
        <Reveal className="mt-12">
          <div className="border border-ink bg-cream overflow-hidden grid md:grid-cols-2">
            <div className="bg-lav relative min-h-[260px] flex items-center justify-center p-8 border-b md:border-b-0 md:border-r border-ink">
              <img src={pouches} alt="Trio Bundle" className="w-full max-w-sm" loading="lazy" />
            </div>
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <span className="kicker bg-lime text-ink border border-ink rounded-full px-3 py-1 self-start">
                {t.save} €12
              </span>
              <h3 className="display uppercase text-4xl md:text-6xl leading-[0.85] mt-4 text-brand">{t.bundleTitle}</h3>
              <p className="mt-3 text-ink/70 font-medium max-w-md">{t.bundleSub}</p>
              <div className="mt-6 flex items-center gap-4">
                <span className="display text-4xl text-ink">€{BUNDLE.price}</span>
                <span className="text-ink/40 line-through text-xl font-bold">€{BUNDLE.listPrice}</span>
              </div>
              <Link to="/shop" data-testid="bundle-cta" className="btn-primary h-14 px-8 mt-6 self-start">
                {t.bundleCta} <ArrowRight className="w-5 h-5" strokeWidth={2} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ProductShowcase;
